import { Moon } from "lucide-react";

const ServerResting = () => (
  <div className="min-h-screen bg-black flex items-center justify-center p-4" data-testid="server-resting-screen">
    <div className="text-center max-w-md">
      <Moon className="w-24 h-24 text-[#EFDF00] mx-auto mb-8 animate-pulse" strokeWidth={1.8} />
      <h1 className="font-nouvel text-4xl text-white mb-5">Auto Thurm</h1>
      <div className="bg-[#EFDF00] p-6 mb-6">
        <h2 className="font-read font-bold text-lg text-black uppercase mb-2">Ruhephase</h2>
        <p className="font-read text-black" data-testid="server-resting-text">
          Der Server ist im Moment in Ruhephase. Bitte schauen Sie später wieder vorbei.
        </p>
      </div>
      <div className="text-[#888B8D] font-read text-sm">
        <p>Bei dringenden Anfragen erreichen Sie uns unter:</p>
        <p className="text-white mt-2 font-bold">Tel: 09682 722</p>
      </div>
    </div>
  </div>
);

export default ServerResting;
